module.exports = __webpack_public_path__ + "static/bike-514fbd20687a5d97693535e922b5ae40.webm";